import React from 'react';
import PropTypes from 'prop-types';

import 'src/components/OffersAmount.scss';


const limitToFitInCircle = 9;

const OffersAmount = ({ amount }) => (
  <span data-test="text-counter" styleName="counter">
    { amount > limitToFitInCircle ? `+${limitToFitInCircle}` : amount }
  </span>
);

OffersAmount.propTypes = {
  amount: PropTypes.number.isRequired
};

export default OffersAmount;
